<template>
  <div>
    <a class="textBrowserOnly" href="#checkoutContent">Skip To Content</a>
    <checkout-header></checkout-header>
    <div id="preCheckoutContent" class="precheckout">
      <div class="container">
        <div class="precheckout-header">
            <div class="pre-checkout-h1">You may also love</div>
            <div class="d-none d-md-block">
                <a
                  :href="ageVerificationRequired ? '/verify-age' : '/checkout'"
                  class="system-link-fat ">
                  Skip
                </a>
            </div>
        </div>

        <error-container v-bind:type="'general'"></error-container>
        <div class="row">
            <transition-group name="fade" mode="out-in" appear class="col product-grid" tag="div">
              <product-card
                v-for="(product, index) in $store.state.profile.upsells.featuredProductRecommendations" :key="product.id"
                listname="Interstitial - You may also love"
                size="medium"
                reco="default"
                :product="product"
                bucket="cart"
                :position="index + 1"
                :collection="true"
                preferenceVerticalPosition="top"
              ></product-card>
            </transition-group>
        </div>
        <!-- ./row -->
      </div>
      <!-- ./container -->
      <sticky-footer
        class="sticky-footer"
        v-bind:isDelivery="false"
        v-bind:cartTotalCardInfo="cartTotalCardInfo"
      ></sticky-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import components from "../../../shared/components.js";
import CheckoutHeader from "../../../shared/components/checkout/CheckoutHeader";

export default {
  name: "Precheckout",
  components: {
    "checkout-header": CheckoutHeader,
    "product-card": components.ProductCard,
    "sticky-footer": components.NavigationFooter,
    "error-container": components.Errors
  },
  data() {
    return {
      cartTotalCardInfo: {
        showSubTotal: true,
        showPersonalShoppersFee: true,
        showSubmitBtn: true,
        showPromoCodeInput: true,
        showDesclaimerText: false,
        showAllSavingsSection: true,
        showViewMyOrder: false,
        showTaxAmount: false,
        showPriceTotal: false,
        showTotalSavingsSection: true,
        gratuityText: "Driver Tip",
        submitButtonText: "Checkout Now",
        btnRoutePath: "/checkout"
      }
    };
  },
  computed: {
    ...mapState({
      ageVerificationRequired: state => state.cart.ageVerificationRequired,
    }),
  },
  methods: {
    fetchUpsells: function() {
      this.$store.dispatch(
        "profile/FETCH_UPSELL",
        {
          name: "featuredProductRecommendations",
          count: 30
        }
      ).then(status => {
        if (status === 200 && this.$store.state.profile.upsells.featuredProductRecommendations.length === 0) {
          // Upsell successfully returned zero products, skip past this page.
          if (this.ageVerificationRequired) {
            window.location = "/verify-age";
          } else {
            this.$router.push({path: '/checkout'})
          }
        }
      })
    },
    },
    mounted: function() {
      if (window.heb.data.user.isGuest) {
        window.location.href = window.heb.data.user.loginURL;
      }
      this.$store.dispatch("errors/CLEAR_ERRORS");
      this.$store.dispatch("cart/SET_FETCHING_CART", true);
      this.$store.dispatch("cart/LOAD_CART", false);

      // hide the regular header
      document.getElementById("header").style.display = "none";

      this.fetchUpsells();
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../shared/assets/lib";

.checkout-heading {
  font-size: 16px;
  font-weight: bold;
}

.pre-checkout-h1 {
  font-size: 20px;
  font-weight: 800;
  padding: 24px 0 16px 0;
  text-align: center;
}

.product-grid{
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 272px));
    grid-gap: 8px;

    .product-card--medium{
      width: unset;
    }

    @media screen and (min-width: $breakpoint-tablet) {
        grid-template-columns: repeat(4, minmax(140px, 272px));
        grid-gap: 12px;
    }

     @media screen and (min-width: $breakpoint-desktop) {
        grid-template-columns: repeat(5, minmax(140px, 272px));
    }
}

@media screen and (min-width: $breakpoint-tablet) {
    .pre-checkout-h1{
        text-align: start;
    }
    .precheckout-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}

.fade-enter-active {
  transition: opacity 0.3s ease-out;
}
.fade-leave-active {
  transition: opacity 0.2s ease-in;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>